import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TopicCardComponent } from './components/topic-card/topic-card.component';
import { VideoCardComponent } from './components/video-card/video-card.component';
import { InteractDirective } from './directives/interact.directive';
import { SubstitutionFieldsComponent } from './components/substitution-fields/substitution-fields.component';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { LanguageSelectorComponent } from 'src/app/components/language-selector/language-selector.component';
import { TranslateDirective } from 'src/app/directives/translate.directive';



@NgModule({
  declarations: [
	TopicCardComponent,
	VideoCardComponent,
	InteractDirective,
	SubstitutionFieldsComponent,
	LanguageSelectorComponent,
	TranslateDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    InputTextModule,
    DropdownModule,
  ],
  exports: [
	TopicCardComponent,
	VideoCardComponent,
	InteractDirective,
	SubstitutionFieldsComponent,
	LanguageSelectorComponent,
	TranslateDirective,
  ]
})
export class SharedModule { }
